import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import Header from './Header'
import Footer from './Footer'
import './styles/styles.css'

const Layout = ({ children, layoutFull, rental  }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet>
          <title>Surventure Camperbouw</title>
          <html lang="nl" />
          <link rel="preload" as="font" crossOrigin="crossorigin" type="font/woff2" href="/DINNextLTPro-Light.woff2" />
          <link rel="preload" as="font" crossOrigin="crossorigin" type="font/woff2" href="/DINNextLTPro-Regular.woff2" />
          <link rel="preconnect" href="https://images.ctfassets.net/" />
          <link rel="preconnect" href="https://www.google-analytics.com" />
        </Helmet>
        <Header fullscreen={layoutFull} />
        <div id="contentContainer">
          {children}
        </div>
        <Footer rental={rental ? rental : false} />
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
